import { TEDMixedType } from '../../../../../../Types/GraphQLTypes';

export function findKey(data: TEDMixedType): string | null {
  for (const key in data) {
    if (
      key !== '__typename' &&
      key !== 'Symbol(id)' &&
      Object.prototype.hasOwnProperty.call(data, key)
    ) {
      if ((data as unknown as Record<string, unknown>)[key] !== null) {
        return key;
      }
    }
  }

  return null;
}
